export const BettingSites = [
    {
        id: 1, rank: 1, name: "Marca", bonoEuros: 200, bonoCasino: 200, reviewUrl: "/opiniones_marca_apuestas", bonoUrl:
            "https://www.marcaapuestas.es/mas/bono-200-euros-apuestas-deportivas/", bonoUrlCasino:
            "https://www.marcaapuestas.es/casino/promociones", rating: 4.5, active: true,
        shortText:"Excelente cobertura de ligas y competiciones deportivas. Para el futbol, la variedad es tan amplia que podrías incluso llegar a descubrir ligas que no conocías."
    },
    {
        id: 2, rank: 2, name: "Codere", bonoEuros: 200, bonoCasino: 200, reviewUrl: "/bono_codere", bonoUrl:
            "https://m.apuestas.codere.es/deportes/index.htm#/PromotionsPage", bonoUrlCasino:
            "https://m.apuestas.codere.es/deportes/index.htm#/PromotionsPage", rating: 4.3, active: true,
        shortText: "La casa de apuestas oficial del Real Madrid. Posibilidad de ingresar y retirar dinero en más de 2000 locales físicos en toda España. Una propuesta realmente interesante."
    },
    {
        id: 3, rank: 3, name: "Luckia", bonoEuros: 200, bonoCasino: 200, reviewUrl: "/bono_luckia", bonoUrl:
            "https://www.luckia.es/promociones/detalle/-/ver/bienvenida-apuest-3/", bonoUrlCasino:
            "https://www.luckia.es/promociones/detalle/-/ver/bienvenida-casino/", rating: 4.25, active: true,
        shortText: "Casa de apuestas española de rápido crecimiento gracias a sus esplendidos bonos para nuevos usuarios. Presencia extendida en salones físicos. "
    },
    {
        id: 4, rank: 4, name: "Paston", bonoEuros: "200", bonoCasino: "1500", reviewUrl: "/paston", bonoUrl:
            "https://www.paston.es/promociones.html#", bonoUrlCasino: "https://www.paston.es/promociones.html#", rating: 4.1, active: false,
        shortText: "Esta nueva casa de apuesta deportiva y juegos de casino online esta experimentando un crecimiento exponencial gracias a sus suculentos bonos para nuevos usuarios"
    },
    {
        id: 5, rank: 5, name: "Bwin", bonoEuros: "-", bonoCasino: "-", reviewUrl: "/bwin", bonoUrl:
            "https://promo.bwin.es/es/promo/offers/p/sportsbook", bonoUrlCasino: "https://promo.bwin.es/es/promo/offers/p/casino",
        rating: 4.1, active: false,
        shortText: "Propuesta completísima, 90 modalidades deportivas distintas y salas de póker potentes con más de 400.000 jugadores.  Probablemente la web de apuestas más conocida de Europa."
    },
    {
        id: 6, rank: 6, name: "William Hill", bonoEuros: 200, bonoCasino: 200, reviewUrl: "/williamhill", bonoUrl:
            "https://promociones.williamhill.es/", bonoUrlCasino: "https://casino.williamhill.es/promociones", rating: 4.0, active:
            false,
        shortText: "Casa de apuesta deportiva solida y de base británica. Mucha profundidad para deportes británicos y europeos. El deporte estrella son las carreras de caballo."
    },
    {
        id: 7, rank: 7, name: "Betfair", bonoEuros: 25, bonoCasino: 200, reviewUrl: "/betfair", bonoUrl:
            "https://www.betfair.es/sport/", bonoUrlCasino:
            "https://casino.betfair.es/promociones/bono-de-bienvenida-a-betfair-casino-p/terms-and-conditions", rating: 3.5, active:
            false,
        shortText: " El primer portal en ofrecer apuestas cruzadas en España. Aquí podrás jugar todo excepto Bingo. Su consigna, \"La casa de apuestas más grande del mundo\""
    },
    {
        id: 8, rank: 8, name: "Bet365", bonoEuros: 100, bonoCasino: 100, reviewUrl: "/Bet365", bonoUrl:
            "https://www.bet365.com", bonoUrlCasino: "https://casino.bet365.es/promotionss", rating: 4.2, active: false,
        shortText: "Página pionera de apuestas deportivas y casino online mundialmente conocida. Variedad profundísima, todo un referente del sector"
    },
    {
        id: 9, rank: 9, name: "Sportium", bonoEuros: 100, bonoCasino: 200, reviewUrl: "/sportium", bonoUrl:
            "https://www.sportium.es/apuestas-deportivas", bonoUrlCasino: "https://www.sportium.es/promociones/casino-bienvenida",
        rating: 3.5, active: false,
        shortText: "Eventos en directo, apuestas variadas y promociones que se renuevan semanal y mensualmente. Ademas cuenta con una red de establecimientos repartidos por España."
    },
    {
        id: 10, rank: 10, name: "Betway", bonoEuros: 150, bonoCasino: 150, reviewUrl: "/Betway", bonoUrl:
            "https://sports.betway.es/es/sports", bonoUrlCasino: "https://casino.betway.es/", rating: 4.6, active: false,
        shortText: "Una de las empresas lideres del sector con bonos de buena calidad. Mas de 700 juegos, una impresionante variedad de deportes y un casino en vivo sólido. "
    },
    {
        id: 11, rank: 11, name: "Botemania", bonoEuros: "-", bonoCasino: 200, reviewUrl: "/bono_botemania", bonoUrl:
            "https://www.botemania.es/register", bonoUrlCasino: "https://www.botemania.es/register", rating: 4.5, active: true,
        shortText: "Una de las webs con mayor aceptación y que es del gusto del jugador español"
    },
    {
        id: 12, rank: 12, name: "Leo Vegas", bonoEuros: 200, bonoCasino: 200, reviewUrl: "/leovegas", bonoUrl:
            "https://www.leovegas.es/es-es/apuestas-deportivas#home", bonoUrlCasino: "https://www.leovegas.es/es-es/", rating: 3.5,
        active: false,
        shortText: ""
    }
]